import Icon from '../components/Icon.vue'

Icon.register({
  'file-csv': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM128 280C128 284.4 124.4 288 120 288H112C103.2 288 96 295.2 96 304V336C96 344.8 103.2 352 112 352H120C124.4 352 128 355.6 128 360V376C128 380.4 124.4 384 120 384H112C85.5 384 64 362.5 64 336V304C64 277.5 85.5 256 112 256H120C124.4 256 128 259.6 128 264V280zM172.3 384H160C155.6 384 152 380.4 152 376V360C152 355.6 155.6 352 160 352H172.3C178.2 352 182.7 348.5 182.7 345.4 182.7 344.1 181.9 342.7 180.6 341.5L158.7 322.8C150.2 315.6 145.3 305.3 145.3 294.6 145.3 273.3 164.4 256 187.8 256H200C204.4 256 208 259.6 208 264V280C208 284.4 204.4 288 200 288H187.7C181.8 288 177.3 291.5 177.3 294.6 177.3 295.9 178.1 297.3 179.4 298.5L201.3 317.2C209.8 324.5 214.7 334.7 214.7 345.4 214.7 366.7 195.7 384 172.3 384zM256 264V284.8C256 305.1 261.7 325 272 341.7 282.3 325 288 305.1 288 284.8V264C288 259.6 291.6 256 296 256H312C316.4 256 320 259.6 320 264V284.8C320 320.3 307.1 353.7 283.7 378.9 280.7 382.1 276.5 384 272 384S263.3 382.1 260.3 378.9C236.9 353.7 224 320.3 224 284.8V264C224 259.6 227.6 256 232 256H248C252.4 256 256 259.6 256 264zM377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-csv.js
// module id = 4gXI
// module chunks = 144